import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'catalog-marital-statuses',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'catalog-marital-statuses-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                                        {
                        transKey: 'breadcrumbs.official-catalogs',
                        isActive: false
                    },
                    {
                        transKey: 'breadcrumbs.catalog-marital-statuses-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "catalog-marital-statuses-index" */ '@/modules/configurations/catalogs/catalog-marital-statuses/views/Index.vue')
        }
    ]
}
